<section class="global-score relative">
	<app-fireworks #fw />

	<img
		pAnimateOnScroll
		enterClass="animate-enter fade-in-10 slide-in-from-b-5 animate-duration-700"
		[src]="profilePic"
		alt="Profile Picture"
		class="global-score__img"
	/>
	<h2
		pAnimateOnScroll
		enterClass="animate-enter fade-in-10 slide-in-from-b-5 animate-duration-700"
	>
		Felicidades {{ name }}!!
	</h2>
	<h4
		pAnimateOnScroll
		enterClass="animate-enter fade-in-10 slide-in-from-b-5 animate-duration-700"
	>
		Sumaste {{ newScore - oldScore }} Capy-Puntos 🦫
	</h4>
	<p
		pAnimateOnScroll
		enterClass="animate-enter fade-in-10 slide-in-from-b-5 animate-duration-700"
	>
		Seguí así para subir de nivel y alcanzar mejores promociones y
		descuentos 🔥
	</p>
</section>
